import * as React from 'react';

import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
/* tslint:disable-next-line:import-name */
import ClickOutside from 'react-click-outside';

import { type InputSize } from '~/constants/form';
import { colors, zIndexValues } from '~/styles/constants';

const DropdownContainer = styled('div')<{ relativeToParent: boolean }>`
  ${(props) => (props.relativeToParent ? '' : 'position: relative;')};
  line-height: 1;
  width: inherit;
`;

const dropdownBorder = '#e1e1e1';

interface DropdownContentContainerProps {
  allowOverflow: boolean;
  className?: string;
  disabled?: boolean;
  minWidth?: InputSize | string;
  onClickOutside: (evt: React.MouseEvent) => void;
  openFromBottomToTop?: boolean;
  reversed?: boolean;
  rightAlign?: boolean;
}

const DropdownContentContainer = styled(ClickOutside, {
  shouldForwardProp: isPropValid,
})<DropdownContentContainerProps>`
  border-radius: 6px;
  position: absolute;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  z-index: ${zIndexValues.dropdown};
  background-color: white;
  ${(props) => (props.allowOverflow ? '' : 'overflow: hidden;')};
  ${(props) => (props.rightAlign ? '' : 'left: 0')};
  right: 0;
  min-width: ${(props) => (props.minWidth ? `${props.minWidth}px` : 'none')};

  ${(props) => (props.reversed ? 'bottom: 100%' : '')};
  ${(props) => (props.openFromBottomToTop ? 'bottom: 0' : '')};

  box-shadow:
    2px ${({ reversed }) => (reversed ? '-2px' : '2px')} 2px ${colors.form.greyBorder},
    -2px ${({ reversed }) => (reversed ? '0px' : '2px')} 2px ${dropdownBorder};
`;

interface DropdownProps {
  allowOverflow?: boolean;
  children?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  isOpen?: boolean;
  minWidth?: InputSize | string;
  onClickOutside?(evt?: React.MouseEvent): void;
  onClose?(): void;
  openFromBottomToTop?: boolean;
  relativeToParent?: boolean;
  reversed?: boolean;
  rightAlign?: boolean;
  size?: InputSize;
  triggerComponent?(onClick?: () => void): React.ReactNode;
}

class Dropdown extends React.Component<DropdownProps> {
  closeDropDown = (evt?: React.MouseEvent) => {
    if (this.props.onClickOutside) this.props.onClickOutside(evt);
    else if (this.props.onClose) this.props.onClose();
  };

  renderContent = () => {
    if (!this.props.isOpen) return null;

    return (
      <DropdownContentContainer
        allowOverflow={this.props.allowOverflow!}
        className={this.props.className}
        minWidth={this.props.minWidth}
        onClickOutside={this.closeDropDown}
        openFromBottomToTop={this.props.openFromBottomToTop}
        reversed={this.props.reversed}
        rightAlign={this.props.rightAlign}
      >
        {this.props.children}
      </DropdownContentContainer>
    );
  };

  constructor(props: DropdownProps) {
    super(props);
  }

  render() {
    const { triggerComponent } = this.props;
    const trigger = triggerComponent ? triggerComponent() : null;

    return (
      <DropdownContainer relativeToParent={this.props.relativeToParent!}>
        {trigger}
        {this.renderContent()}
      </DropdownContainer>
    );
  }
}

export default Dropdown;
